import tippy from 'tippy.js';

function addTooltips() {

    const TOOLTIPS = document.querySelectorAll('.tooltip[data-tippy-content]');

    if (TOOLTIPS) {

        for (let i = 0; i < TOOLTIPS.length; i++) {

            const TOOLTIP = TOOLTIPS[i];

            // Setup options
            let options = {
                arrow: true,
                maxWidth: 270,
                distance: 20,
                zIndex: 99999999
            };

            // Add placement
            if ( TOOLTIP.getAttribute('data-placement') ) {
                options.placement = TOOLTIP.getAttribute('data-placement');
            }
            
            tippy(TOOLTIP, options);
        }
    }
}

export { addTooltips }